<template>
    <div class="reports">
        <div class="modal-list" :class="{'display': !isOpen}">
            <div>
                <h3 @click="isOpen = false">X</h3>
                <center>
                    <h3>Agregar ingreso manual</h3>
                </center>
                <span v-if="modelSelected" @click="modelSelected = !modelSelected"><i class="fa-solid fa-arrow-left"></i></span>
                <div v-else class="list">
                    <input type="text" v-model="searchValueModel" v-on:keyup="checkTriggerModel" @keyup.enter="onEnterModel">
                    <div class="model-list" v-infinite-scroll="loadMoreModels" infinite-scroll-disabled="busyModels" infinite-scroll-distance="200">
                        <div v-for="(model, index) in models" @click="selectModel(model, index)" :key="index" :class="{'select': model.select}">
                            <div>
                                <center><img :src="model.image" alt=""></center>
                                <h5 for="">{{ model.name }}</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="modelSelected" class="pending-info">
                    <div class="model-info">
                        <h3>Información</h3>
                        <img :src="userImgselect" alt="">
                        <div>
                            <h5>{{ userNameSelect }}</h5>
                        </div>
                    </div>
                    <div class="pending">
                        <div>
                            <h3>Agregar</h3>
                            <input type="number" name="" id="" v-model="skyprivateLedger">
                        </div>
                        <button @click="addSkyprivateLedgers()">Agregar ingresos</button>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div>
                <div class="informes">
                    <div>
                        <div><label>Modelos<br><br> <span>{{cantModelos}}</span></label></div>
                        <div><label>Dolares <br><br> <span>{{priceFormat(totalDolars)}}</span></label></div>
                        <div><label>Tokens <br><br> <span>{{parseInt(totalDolars / 0.05)}}</span></label></div>
                    </div>
                </div>
                <div class="ledgers">
                    <div>
                        <button @click="isOpen = true">Agregar Ingresos</button>
                        <h3 for="">Ultimos ingresos</h3>
                        <input type="date" v-model="searchValue" v-on:keyup="checkTrigger" @keyup.enter="onEnter">
                        <center>
                            <table v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="200">
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Modelo</th>
                                        <th>Tokens</th>
                                        <th>Dolar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ledger, index) in ledgers" :key="index">
                                        <td>{{ledger.date.split($store.state.constants.SEPARETOR)[0]}}</td>
                                        <td>{{ledger.modelo}}</td>
                                        <td>{{ledger.tokens}}</td>
                                        <td>{{priceFormat(ledger.dolars)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div>
                <div class="modelos">
                    <div>
                        <div>
                            <h4>Mayor Producción</h4>
                            <center>
                                <table>
                                    <tbody>
                                        <tr v-for="(platform, index) in bestModels" :key="index">
                                            <td>{{platform.modelo}}</td>
                                            <td>{{priceFormat(platform.balance)}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </center>
                        </div>
                        <div>
                            <h4>Menor Producción</h4>
                            <center>
                                <table>
                                    <tbody>
                                        <tr v-for="(platform, index) in worseModels" :key="index">
                                            <td>{{platform.modelo}}</td>
                                            <td>{{priceFormat(platform.balance)}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </center>
                        </div>
                    </div>
                </div>
                <div class="fechas">
                    <div>
                        <div>
                            <div>
                                <label for="">Total Ayer<br><br> <span>{{priceFormat(totalTokensToday)}}</span></label>
                            </div>
                            <div>
                                <label for="">Studio ganancias <br><br> <span>{{priceFormat(studioTotal)}}</span></label>
                            </div>
                        </div>
                        <div>
                            <div>
                                <label for="" v-if="bestDay">Dia mas vendido <br><br> <span>fecha: {{bestDay.created_at !== null ? bestDay.created_at.split("T")[0] : ''}} <br>total: {{bestDay.total !== null ? priceFormat(bestDay.total): priceFormat(0.00)}}</span></label>
                            </div>
                            <div>
                                <label for="" v-if="worseDay">Dia menos vendido <br><br> <span>fecha: {{worseDay.created_at !== null ? worseDay.created_at.split("T")[0]: ''}} <br>total: {{worseDay.total !== null ? priceFormat(worseDay.total): priceFormat(0.00)}}</span></label>
                            </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Price from '@/utils/ConvertPriceNumber'
import Notify from '@/utils/Notification'

export default {
    data() {
        return {
            cantModelos: null,
            totalDolars: null,
            totalTokens: null,
            ledgers: [],
            limit: 20,
            offset: 0,
            busy: false,
            listEnd: false,
            itemFlag: false,
            bestModels: [],
            worseModels: [],
            totalTokensToday: 0,
            bestDay: null,
            worseDay: null,
            studioTotal: 0.00,
            searchValue: '',
            isOpen: false,
            modelSelected: null,
            searchValueModel: '',
            models: [],
            limitModels: 20,
            offsetModels: 0,
            busyModels: false,
            listEndModels: false,
            itemFlagModels: false,
            userIdSelect: null,
            userImgselect: null,
            userNameSelect: null,
            userTypeSelect: null,
            skyprivateLedger: 0
        }
    },
    watch: {
        searchValue: function() {
            if (this.searchValue === '') {
                this.ledgers = []
                this.getPlatformsLedgers()
            }
        },
        searchValueModel: function() {
            if (this.searchValueModel === '') {
                this.models = []
                this.getAllModels()
            }
        }
    },
    methods: {
        checkTriggerModel(e) {
            if (e.keyCode === 13) {
                this.limitModels = 20
                this.offsetModels = 0
                this.models = []
                this.searchModel()
            } else if (this.searchValueModel.length > 0) {
                this.limitModels = 20
                this.offsetModels = 0
                this.models = []
                this.searchModel()
            }
        },
        addSkyprivateLedgers() {
            if (this.skyprivateLedger === 0) {
                return
            }
            API.addSkyprivateLedgers(this.skyprivateLedger, this.userIdSelect)
                .then((res) => {
                    this.skyprivateLedger = 0
                    this.isOpen = false
                    this.limit = 20
                    this.offset = 0
                    this.ledgers = []
                    this.getPlatformsLedgers()
                })
                .catch(() => {
                    Notify('error', 'No se cargo la informacion para esta modelo primero debes registrar la plataforma')
                })
        },
        onEnterModel () {
            this.searchModel()
        },
        searchModel() {
            this.modelSearch = false
            this.getAllModels()
        },
        selectModel(model) {
            this.models.map(model => { model.select = false })
            model.select = true
            this.userIdSelect = model.id
            this.modelSelected = true
            this.userImgselect = model.image
            this.userNameSelect = model.name
            this.userTypeSelect = model.type
        },
        getAllModels() {
            const limit = this.searchValueModel === '' ? this.limitModels : 'ALL'
            const offset = this.searchValueModel === '' ? this.offsetModels : 0
            var searchValueinitial = ''
            if (this.searchValueModel !== '') {
                var stagenameSeparate = this.searchValueModel.split(' ')
                if (stagenameSeparate.length > 1) {
                    for (let index2 = 0; index2 < stagenameSeparate.length; index2++) {
                        searchValueinitial += stagenameSeparate[index2] + '_'
                    }
                    searchValueinitial = searchValueinitial.slice(0, -1)
                } else {
                    searchValueinitial = this.searchValueModel
                }
            } else {
                searchValueinitial = this.searchValueModel
            }
            API.getAllModelsSearch(limit, offset, searchValueinitial)
                .then((res) => {
                    if (this.searchValueModel !== '') {
                        this.models = res
                    } else {
                        res.map(item => { this.models.push(item) })
                        this.offsetModels += this.limitModels
                        this.itemFlagModels = true
                    }
                })
        },
        loadMoreModels() {
            if (this.searchValue !== '') {
                return
            }
            this.busyModels = true
            if (!this.listEndModels) {
                setTimeout(() => {
                    if (this.models.length < this.offsetModels) {
                        this.listEndModels = true
                        return
                    }
                    if (this.itemFlagModels) {
                        this.getAllModels()
                        this.busyModels = false
                    } else {
                        this.loadMoreModels()
                    }
                }, 1000)
            }
        },
        checkTrigger(e) {
            if (e.keyCode === 13) {
                this.limit = 20
                this.offset = 0
                this.ledgers = []
                this.searchLedger()
            } else if (this.searchValue.length > 0) {
                this.limit = 20
                this.offset = 0
                this.ledgers = []
                this.searchLedger()
            }
        },
        onEnter () {
            this.searchLedger()
        },
        searchLedger() {
            this.modelSearch = false
            this.getPlatformsLedgers()
        },
        priceFormat: function(item) {
            return Price(item)
        },
        getTotalModels() {
            API.getTotalModelsByPlatform('Skyprivate')
                .then((res) => {
                    this.cantModelos = res.cantidad
                })
        },
        getTotalDollars() {
            API.getTotalDollarsByPlatform('Skyprivate')
                .then((res) => {
                    this.totalDolars = res.dolars
                })
        },
        getPlatformsLedgers() {
            const limit = this.searchValue === '' ? this.limit : 'ALL'
            const offset = this.searchValue === '' ? this.offset : 0
            var searchValueinitial = ''
            if (this.searchValue !== '') {
                var stagenameSeparate = this.searchValue.split(' ')
                if (stagenameSeparate.length > 1) {
                    for (let index2 = 0; index2 < stagenameSeparate.length; index2++) {
                        searchValueinitial += stagenameSeparate[index2] + '_'
                    }
                    searchValueinitial = searchValueinitial.slice(0, -1)
                } else {
                    searchValueinitial = this.searchValue
                }
            } else {
                searchValueinitial = this.searchValue
            }
            API.getPlatformsLedgers(limit, offset, 'Skyprivate', searchValueinitial)
                .then((res) => {
                    if (this.searchValue !== '') {
                        this.ledgers = res
                    } else {
                        res.map(ledger => { this.ledgers.push(ledger) })
                        this.offset += this.limit
                        this.itemFlag = true
                    }
                })
        },
        loadMore() {
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.ledgers.length < this.offset) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getPlatformsLedgers()
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        },
        getBetsModels() {
            API.getModelsPlatformRanking('Skyprivate', 'ASC')
                .then((res) => {
                    this.worseModels = res
                })
        },
        getWorseModels() {
            API.getModelsPlatformRanking('Skyprivate', 'DESC')
                .then((res) => {
                    this.bestModels = res
                })
        },
        getTotalTokensToday() {
            API.getTotalTokensToday('Skyprivate')
                .then((res) => {
                    this.totalTokensToday = res.total
                })
        },
        getWorseDay() {
            API.getDayPlatformRanking('Skyprivate', 'ASC')
                .then((res) => {
                    this.worseDay = res
                })
        },
        getBestDay() {
            API.getDayPlatformRanking('Skyprivate', 'DESC')
                .then((res) => {
                    this.bestDay = res
                })
        },
        getPlatformsStudioTotal() {
            API.getPlatformsStudioTotal('Skyprivate')
                .then((res) => {
                    this.studioTotal = res.total
                })
        }
    },
    mounted() {
        this.getTotalModels()
        this.getTotalDollars()
        this.getPlatformsLedgers()
        this.getBetsModels()
        this.getWorseModels()
        this.getTotalTokensToday()
        this.getWorseDay()
        this.getBestDay()
        this.getPlatformsStudioTotal()
        this.getAllModels()
    },
    beforeMount() {
        this.$root.$emit('changePlatform', this.$route.name)
    }
}
</script>

<style scoped>
    .reports{
        width: 100%;
        height: 78vh;
        background-color: #cdcdcd;
        display: flex;
        position: relative;
    }
    .reports > div.modal-list {
        position: absolute;
        padding: 20px;
        height: 100%;
        width: 100%;
        background-color: rgba(43, 41, 38, 0.7);
        z-index: 99;
        border-radius: 0px;
    }
    .reports > div.modal-list > div{
        background-color: #FFF;
        height: 90%;
        width: 90%;
        padding: 20px;
        color: #000;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }
    .reports > .display{
        display: none;
    }
    .reports > div.modal-list > div > div.list{
        padding: 20px;
        height: 100%;
    }
    .reports > div.modal-list > div > div.list > input{
        width: 100%;
        height: 50px;
        border-radius: 20px;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .reports > div.modal-list > div > div.list > div.model-list{
        padding: 20px;
        overflow: auto;
        height: 80%;
        position: relative;
    }
    .reports > div.modal-list > div > div.list > div.model-list > div{
        width: 25%;
        display: inline-block;
    }
    .reports > div.modal-list > div > div.list > div.model-list > div.select {
        background-color: #63b763;
    }
    .reports > div.modal-list > div > div.list > div.model-list > div > div{
        padding: 20px;
        width: 100%;
        text-align: center;
    }
    .reports > div.modal-list > div > div.list > div.model-list > div > div > center > img{
        width: 50%;
        height: 50%;
        object-fit: cover;
    }
    .reports > div.modal-list > div > button {
        position: absolute;
        top: 30px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .reports > div.modal-list > div > h3 {
        font-weight: bolder;
        position: absolute;
        right: 20px;
    }
    .reports > div.modal-list > div > span > svg {
        font-weight: bolder;
        position: absolute;
        left: 20px;
        top: 27px;
        font-size: 28px;
    }
    .reports > div.modal-list > div > h3:hover {
        color: red;
        cursor: pointer;
    }
    .reports > div.modal-list > div > span > svg:hover {
        color: red;
        cursor: pointer;
    }
    .reports > div.modal-list > div > div.pending-info {
        width: 100%;
        height: 100%;
        display: flex;
    }
    .reports > div.modal-list > div > div.pending-info > div.model-info {
        width: 30%;
        height: 90%;
        text-align: center;
        padding: 20px;
        position: relative;
    }
    .reports > div.modal-list > div > div.pending-info > div.model-info > button{
        position: absolute;
        bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .reports > div.modal-list > div > div.pending-info > div.model-info > img {
        width: 250px;
        height: 250px;
        object-fit: cover;
        margin-top: 40px;
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
    }
    .reports > div.modal-list > div > div.pending-info > div.model-info > div {
        position: absolute;
        bottom: 20%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .reports > div.modal-list > div > div.pending-info > div.pending {
        width: 100%;
        height: 100%;
        padding: 30px;
        position: relative;
    }
    .reports > div.modal-list > div > div.pending-info > div.pending > button{
        position: absolute;
        bottom: 100px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .reports > div.modal-list > div > div.pending-info > div.pending > div {
        text-align: center;
        padding: 50px;
    }
    .reports > div.modal-list > div > div.pending-info > div.pending > div > select {
        height: 40px;
        width: 300px;
        border-radius: 20px;
        text-align: center;
    }
    .reports > div.modal-list > div > div.pending-info > div.pending > div > h3 {
        margin: 20px;
        margin-bottom: 70px;
    }
    .reports > div.modal-list > div > div.pending-info > div.pending > div > input {
        height: 40px;
        width: 300px;
        border-radius: 20px;
        text-align: center;
    }
    .reports > div {
        width: 50%;
        text-align: center;
        height: 100%;
    }
    .reports > div > div{
        width: 100%;
        text-align: center;
        height: 100%;
    }
    .reports > div > div > div.informes {
        width: 100%;
        height: 30%;
        padding: 10px;
    }
    .reports > div > div > div.ledgers {
        width: 100%;
        height: 70%;
        padding: 10px;
    }
    .reports > div > div > div.modelos {
        width: 100%;
        height: 50%;
        padding: 10px;
    }
    .reports > div > div > div.fechas {
        width: 100%;
        height: 50%;
        padding: 10px;
    }
    .reports > div > div > div.informes > div{
        background-color: #2b2926;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
        padding: 10px;
        color: #fff;
        display: flex;
    }
    .reports > div > div > div.informes > div > div{
        width: 33%;
        height: 100%;
        position: relative;
    }
    .reports > div > div > div.informes > div > div > label{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: bold;
    }
    .reports > div > div > div.informes > div > div > label > span{
        font-size: 28px;
    }
    .reports > div > div > div.ledgers > div{
        background-color: #2b2926;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
        padding: 10px;
        color: #fff;
    }
    .reports > div > div > div.ledgers > div > button {
        position: absolute;
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 40px;
        border-radius: 30px;
        left: 60px;
    }
    .reports > div > div > div.ledgers > div > center{
        margin-top: 20px;
        overflow-y: auto;
        height: 80%;
    }
    .reports > div > div > div.ledgers > div > center > table > thead > tr > th {
        border-style: outset;
        padding: 20px 40px;
        text-align: center;
    }
    .reports > div > div > div.ledgers > div > center > table > tbody > tr > td {
        border-style: outset;
        padding: 10px 20px;
        text-align: center;
    }
    .reports > div > div > div.modelos > div{
        background-color: #2b2926;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
        padding: 10px;
        color: #fff;
        display: inline-flex;
    }
    .reports > div > div > div.modelos > div > div {
        width: 100%;
        text-align: center;
    }
    .reports > div > div > div.modelos > div > div > center > table > thead > tr > th{
        padding: 20px 40px;
    }
    .reports > div > div > div.modelos > div > div > center > table > tbody > tr > td{
        padding: 20px 40px;
    }
    .reports > div > div > div.fechas > div{
        background-color: #2b2926;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
        padding: 10px;
        color: #fff;
        display: inline-flex;
    }
    .reports > div > div > div.fechas > div > div{
        width: 50%;
        height: 100%;
    }
    .reports > div > div > div.fechas > div > div > div{
        width: 100%;
        height: 50%;
        position: relative;
    }
    .reports > div > div > div.fechas > div > div > div > label{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: bold;
        width: 100%;
    }
    .reports > div > div > div.fechas > div > div > div > label > span{
        font-size: 26px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Reportes/Plataformas/SkyPrivate.vue